import React from 'react'
import { KPICard } from '@pushly/aqe/lib/components'
import { DefinitionTooltip } from '../../components/definition-tooltip'
import { DeltaText } from '../../components/delta-text'
import { Sparkline } from '../../components/sparkline'
import { HeadlineTile } from './headline-model'

/*
 * The card's built-in delta chip only shows a signed percentage in a good/bad colour pair, so the change is
 * passed as `deltaSlot`: DeltaText shows percentage points for a rate, a gray "Steady" state, and a neutral
 * change for a measure with no good direction. The `sparkline` slot carries a chart that breaks its line on
 * days without data.
 */
export const KpiTile: React.FC<{ tile: HeadlineTile }> = ({ tile }) => {
    const sharedCardProps = {
        label: tile.label,
        formattedValue: tile.formattedValue,
        valueTooltip: tile.fullValue,
        infoSlot: <DefinitionTooltip text={tile.definition} />,
        showRange: false,
        showMore: false,
        className: 'org-dashboard-kpi-tile',
    }

    if (tile.withheld) {
        return (
            <KPICard
                {...sharedCardProps}
                secondaryLine={<span className="org-dashboard-kpi-tile-withheld-reason">{tile.withheld.reason}</span>}
                subtitle={tile.withheld.detail}
            />
        )
    }

    return (
        <KPICard
            {...sharedCardProps}
            deltaSlot={
                <DeltaText
                    chip
                    value={tile.delta.value}
                    kind={tile.delta.kind}
                    goodDirection={tile.goodDirection}
                    steady={tile.delta.steady}
                    comparisonLabel={tile.comparisonLabel}
                />
            }
            secondaryLine={<span className="org-dashboard-kpi-tile-absolute-delta">{tile.absoluteDelta}</span>}
            sparkline={<Sparkline values={tile.sparkline} variant="tile" />}
            subtitle={tile.supporting}
        />
    )
}
